interface EchoArcProps {
  count?: number
  size?: number
  color?: string
  className?: string
}

export function DotCluster({ count = 12, size = 48, color = '#1E2D5A', className = '' }: EchoArcProps) {
  const dots: { cx: number; cy: number; r: number; opacity: number }[] = []
  const sqrt = Math.ceil(Math.sqrt(count))
  let i = 0
  for (let row = 0; row < sqrt && i < count; row++) {
    for (let col = 0; col < sqrt && i < count; col++) {
      dots.push({
        cx: 4 + col * (size / sqrt),
        cy: 4 + row * (size / sqrt),
        r: (size / sqrt) * 0.3,
        opacity: 0.4 + (i / count) * 0.6,
      })
      i++
    }
  }
  return (
    <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`} className={className}>
      {dots.map((d, idx) => (
        <circle key={idx} cx={d.cx} cy={d.cy} r={d.r} fill={color} opacity={d.opacity} />
      ))}
    </svg>
  )
}

// Concept B: confluence lines for explainer diagrams
export function ConfluenceLines({ className = '' }: { className?: string }) {
  return (
    <svg width="120" height="60" viewBox="0 0 120 60" className={className}>
      <path d="M0 10 Q30 10 60 30" stroke="#8896C7" strokeWidth="2" fill="none" opacity="0.7"/>
      <path d="M0 30 Q30 30 60 30" stroke="#1E2D5A" strokeWidth="2" fill="none" opacity="0.9"/>
      <path d="M0 50 Q30 50 60 30" stroke="#8896C7" strokeWidth="2" fill="none" opacity="0.7"/>
      <path d="M60 30 L120 30" stroke="#1E2D5A" strokeWidth="2.5" fill="none"/>
      <circle cx="60" cy="30" r="4" fill="#1E2D5A"/>
      <circle cx="120" cy="30" r="5" fill="#1E2D5A"/>
    </svg>
  )
}

// Concept E: grid + ripple for analytics/ensemble screens
export function GridRipple({ active = false, className = '' }: { active?: boolean; className?: string }) {
  return (
    <svg width="48" height="48" viewBox="0 0 48 48" className={className}>
      {[0,1,2,3].map(row => [0,1,2,3].map(col => (
        <rect
          key={`${row}-${col}`}
          x={col * 11 + 2}
          y={row * 11 + 2}
          width="8"
          height="8"
          rx="1.5"
          fill={row === 1 && col === 1 ? '#1E2D5A' : '#D9D2C2'}
          opacity={active && row === 1 && col === 1 ? 1 : 0.6}
        />
      )))}
      {active && (
        <circle cx="14" cy="14" r="8" fill="none" stroke="#8896C7" strokeWidth="1.5" opacity="0.4"
          className="animate-ripple" style={{ transformOrigin: '14px 14px' }}/>
      )}
    </svg>
  )
}
